import {
  ADVISOR_CLIENT_RECEIVED,
  ADVISOR_CLIENT_PATCHED,
  ADVISOR_CLIENT_RESTOREPOINT,
  ADVISOR_CLIENT_CLOSED
} from './types'

export default function client(state = {}, action = {}){
  switch (action.type) {
    case ADVISOR_CLIENT_RECEIVED:
      return action.data 
    case ADVISOR_CLIENT_PATCHED:
        let patch = {}
        patch[action.data.field] = action.data.value
        return { ...patch }
    case ADVISOR_CLIENT_RESTOREPOINT:
      return {
        ...state,
        restorePoint: action.data
      }
    case ADVISOR_CLIENT_CLOSED:
      return {}
    default:
      return state;
  }
}